import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Star, Download, ShoppingBag, Check } from 'lucide-react';
import Badge from './Badge';
import { useCart } from '../context/CartContext';
import './TemplateCard.css';

const PLACEHOLDER = 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?auto=format&fit=crop&q=80&w=400';

export default function TemplateCard({
  id,
  slug,
  title,
  designer,
  designer_name,
  likes,
  like_count,
  rating,
  avg_rating,
  downloads,
  download_count,
  price,
  price_cents,
  is_free,
  formats = [],
  image,
  preview_url,
  index = 0,
}) {
  const { addItem, items } = useCart();
  const designerName = designer || designer_name || 'Unknown';
  const slugPath = slug || id || '';
  const likeCount = likes ?? like_count ?? 0;
  const ratingVal = rating ?? avg_rating ?? 0;
  const dlCount = downloads ?? download_count ?? 0;
  const imgSrc = image || preview_url || PLACEHOLDER;
  const priceCents = price_cents ?? (price != null ? price * 100 : null);
  const isFree = is_free === 1 || is_free === true || priceCents === null || priceCents === 0;
  const priceDisplay = isFree ? null : (priceCents / 100).toFixed(2);
  const isInCart = items.some(i => i.template_id === id || i.id === id);

  const staggerClass = `stagger-${Math.min((index % 6) + 1, 6)}`;

  const handleQuickCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem({
      id,
      title,
      price_cents: priceCents,
      is_free: isFree,
      preview_url: imgSrc,
      designer_name: designerName,
      formats
    });
  };

  return (
    <Link to={`/template/${slugPath}`} className={`template-card animate-fade-in ${staggerClass}`}>
      <div className="template-preview-wrapper">
        <img
          src={imgSrc}
          alt={title}
          className="template-preview"
          onError={(e) => { e.target.src = PLACEHOLDER; }}
        />
        {!isFree && (
          <button 
            className={`quick-cart-btn ${isInCart ? 'in-cart' : ''}`}
            onClick={handleQuickCart}
            title={isInCart ? 'In cart' : 'Add to cart'}
          >
            {isInCart ? <Check size={15} /> : <ShoppingBag size={15} />}
          </button>
        )}
      </div>
      <div className="template-info">
        <div className="template-header-row">
          <h3 className="template-title" title={title}>{title}</h3>
          {isFree ? (
            <span className="template-price-free">Free</span>
          ) : (
            <span className="template-price-tag">${priceDisplay}</span>
          )}
        </div>

        <div className="template-meta-row">
          <span className="template-designer-name">@{designerName}</span>
          {formats && formats.length > 0 && (
            <div className="template-formats-row">
              {formats.slice(0, 2).map(fmt => (
                <span key={fmt} className="format-pill">{fmt}</span>
              ))}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
